import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { AIFullPageLoader } from 'ai-components-ui-library/components/loading/AIFullPageLoader';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AIVariantCreationInProgressModal = ({
  onClose
}) => /*#__PURE__*/_jsxs(Modal, {
  maxInlineSize: "770px",
  "data-test-id": "ai-variant-in-progress-modal",
  children: [/*#__PURE__*/_jsxs(DialogHeader, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "personalizationLib.creationInProgress.title"
      })
    }), /*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: onClose
    })]
  }), /*#__PURE__*/_jsxs(DialogBody, {
    marginBlockStart: "800",
    children: [/*#__PURE__*/_jsxs(Flex, {
      gap: "200",
      flexDirection: "column",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "personalizationLib.creationInProgress.description.one"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "personalizationLib.creationInProgress.description.two"
      })]
    }), /*#__PURE__*/_jsx(AIFullPageLoader, {
      messages: [I18n.text('personalizationLib.creationInProgress.message')]
    })]
  }), /*#__PURE__*/_jsx(DialogFooter, {})]
});
export default AIVariantCreationInProgressModal;